import { BYTES_PER_MB, BYTES_PER_GB, IMAGE_EXTENSIONS } from './documents.consts'
import type { TUploadListItemFileType } from '../upload-list-item/upload-list-item.types'

export const bytesToMb = (sizeInBytes: number): string => {
  const sizeInMB = sizeInBytes / BYTES_PER_MB
  const precision = sizeInMB < 0.1 ? 2 : sizeInMB < 1 ? 1 : 0

  return sizeInMB.toFixed(precision)
}

export function bytesToGB(bytes: number): number {
  if (bytes <= 0) return 0

  return bytes / BYTES_PER_GB
}

export const getFileTypeFromExtension = (extension: string): TUploadListItemFileType => {
  if (!extension) return 'document'

  const normalizedExtension = extension.toLowerCase().replace('.', '')

  return IMAGE_EXTENSIONS.includes(normalizedExtension) ? 'image' : 'document'
}
